import validator from "validator";

const isNumericMobile = (mobile) => {
  if (!isNaN(mobile)) {
    return true;
  } else {
    return false;
  }
};

const validMobileNumber = (mobile) => {
  if (mobile.charAt(0) == "0" && mobile.charAt(1) == "9") {
    return true;
  } else {
    return false;
  }
};

const lenghtMobileNumber = (mobile) => {
  if (mobile.length == 11) {
    return true;
  } else {
    return false;
  }
};

export default {
  isNumericMobile,
  validMobileNumber,
  lenghtMobileNumber,
};
